import {getEndpoint, getHeaders} from '../../helpers/endpoint';

export const REQUEST_GET_CHAMPIONSHIPS = 'REQUEST_GET_CHAMPIONSHIPS';
export const SUCCESS_GET_CHAMPIONSHIPS = 'SUCCESS_GET_CHAMPIONSHIPS';
export const FAIL_GET_CHAMPIONSHIPS = 'FAIL_GET_CHAMPIONSHIPS';

export const getChampionships = (payload, onSuccess, onError) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_GET_CHAMPIONSHIPS});

    return fetch(getEndpoint('getChampionships', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
          dispatch({
            type: FAIL_GET_CHAMPIONSHIPS,
            error: data.error,
          });
        } else dispatch(successGetChampionships(data, onSuccess));
      })
      .catch((error, type = FAIL_GET_CHAMPIONSHIPS) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successGetChampionships(response, onSuccess) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_GET_CHAMPIONSHIPS,
      response,
    });
  };
}

export const REQUEST_GET_ACTIVE_CHAMPIONSHIPS =
  'REQUEST_GET_ACTIVE_CHAMPIONSHIPS';
export const SUCCESS_GET_ACTIVE_CHAMPIONSHIPS =
  'SUCCESS_GET_ACTIVE_CHAMPIONSHIPS';
export const FAIL_GET_ACTIVE_CHAMPIONSHIPS = 'FAIL_GET_ACTIVE_CHAMPIONSHIPS';

export const getActiveChampionships = (payload, onSuccess, onError) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_GET_ACTIVE_CHAMPIONSHIPS});

    return fetch(getEndpoint('getActiveChampionships', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
          dispatch({
            type: FAIL_GET_ACTIVE_CHAMPIONSHIPS,
            error: data.error,
          });
        } else dispatch(successGetActiveChampionships(data, onSuccess));
      })
      .catch((error, type = FAIL_GET_ACTIVE_CHAMPIONSHIPS) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successGetActiveChampionships(response, onSuccess) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_GET_ACTIVE_CHAMPIONSHIPS,
      response,
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/entities/championships.js